import {Component, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {Program} from '@models/program';
import {Input} from '@node_modules/@angular/core';
import {ProgramCreateComponent} from '@pages/layout/program/program-create/program-create.component';
import {ProgramClassesComponent} from '@pages/layout/program/program-page/program-classes/program-classes.component';
import {MatDialog} from '@node_modules/@angular/material';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {ActionTypes, UpdateProgram} from '@store/program/actions';
import {User} from '@models/user';
import {StudentService} from '@services/student/student.service';
import {Class} from '@models/class';
import * as moment from 'moment';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import {Schedule} from '@models/schedule';
import * as ProgramReducer from '@store/program/reducers';
import {Store} from '@node_modules/@ngrx/store';
import {ClassService} from '@services/class/class.service';
import {ViewCurriculumComponent} from '@pages/layout/program/program-page/program-curriculum/view-curriculum/view-curriculum.component';
import {Curriculum} from '@models/curriculum';
import {ScheduleFacade} from '@facades/schedule/scheduleFacade';
import {UpdateAuthUser} from '@store/auth/actions';
import {Router} from '@node_modules/@angular/router';
import * as AuthReducer from '@store/auth/reducers';
import {AttendanceService} from '@services/attendance/attendance.service';
@Component({
  selector: 'app-program-schedule',
  templateUrl: './program-schedule.component.html',
  styleUrls: ['./program-schedule.component.scss']
})
export class ProgramScheduleComponent implements OnInit, OnDestroy {
  @Input() programSubject: BehaviorSubject<Program>;
  @Input() programs: Program[];
  @Input() source = 'admin';
  @Input() studentReadOnly = false;
  @Input() modules = ['week', 'day', 'month'];
  @Output() scheduleProgram: Subject<string> = new BehaviorSubject(null);
  // scheduleProgram: Subject<string> = new BehaviorSubject(null);
  static lessonNumber = {};
  static schedulesWithLesson = {};
  program: Program;
  onClosePopupClass: Subject<boolean> = new BehaviorSubject(null);
  onTodaySubject: Subject<string> = new BehaviorSubject(null);
  onLeftSubject: Subject<string> = new BehaviorSubject(null);
  onRightSubject: Subject<string> = new BehaviorSubject(null);
  moveStudentsCarousel: Subject<string> = new BehaviorSubject(null);
  schedulesScales: Array<string> = ['day', 'week',  'month'];
  currentScheduleScale = 1;
  currentClass;
  currentDay;
  selectedDay;
  selectedMonth;
  week = [];
  calendarViewDate = moment();
  selectedCalendarDate = null;
  selectedDaySchedules: any[] = [];
  createDialog;
  confirmDialog;
  viewCirriculumDialog;
  students: {[key: number]: User[]} = {};
  user: User;
  static classesByDates = {};
  constructor(
      // private programStore: Store<ProgramReducer.ProgramState>,
      public dialog: MatDialog,
      private router: Router,
      private classService: ClassService,
      private authStore: Store<AuthReducer.AuthState>,
      private studentService: StudentService,
      private attendanceService: AttendanceService,
      private programStore: Store<ProgramReducer.ProgramState>,
  ) { }
  get calendarDisplayMonthYear(): string {
    return this.calendarViewDate.format('MMMM YYYY');
  }
  get displayedSchedules(): any[] {
    return this.selectedCalendarDate ? this.selectedDaySchedules : this.todaySchedules;
  }
  get scheduleDisplayTitle(): string {
    if (!this.selectedCalendarDate || moment(this.selectedCalendarDate).isSame(moment(), 'day')) {
      return 'Today\'s Schedule';
    }
    return 'Schedule for ' + moment(this.selectedCalendarDate).format('MMM D');
  }
  get scheduleEmptyCopy(): string {
    return this.selectedCalendarDate && !moment(this.selectedCalendarDate).isSame(moment(), 'day')
      ? 'No classes scheduled for this day.'
      : 'No classes scheduled today.';
  }
  get scheduleCountLabel(): string {
    const count = this.displayedSchedules.length;

    return count + ' ' + (count === 1 ? 'class' : 'classes');
  }
  get todaySchedules(): any[] {
    if (!this.program || !this.program.classes) {
      return [];
    }
    const today = moment();
    const schedules = [];

    this.program.classes.map(classc => {
      const classSchedules = classc.schedule || [];
      classSchedules.map(schedule => {
        if (this.doesScheduleMatchDate(schedule, today)) {
          schedules.push(this.enrichScheduleForDisplay(Object.assign({}, schedule, {
            class_name: schedule.class_name || classc.name,
            teachers: classc.teachers || []
          }), today));
        }
      });
    });

    return this.sortSchedules(schedules);
  }
  static getClassByDate(current_program: Program, programs: Program[], day, classesByDates: any, withTime = true, time = moment(), defaultFormat = 'MMM Do YY HH:mm A') {
    let index = day + '_' + current_program.program_id;
    // console.log(day, time.format('LLL'), current_program);
    if (withTime) {
      index += time.format('LLL');
    }
    if (!ProgramScheduleComponent.classesByDates[index]) {
      // console.log(day, time.format('LLL'), current_program);
      if (current_program.curriculum && current_program.curriculum.length > 0) {
        current_program.curriculum.map(item => {
          item.order = ScheduleFacade.getTrafficLight(item.start_curriculum, item.end_curriculum, 'YYYY-MM-DD HH:mm:ss');
        });
      }
      let dayFromCalendar = moment(day).hour(time.hour()).minute(time.minute());
      // console.log(day, dayFromCalendar);
      let curriculumSet = false;
      programs.map((progr, i) => {
        progr.classes.map((item, y) => {
          item.schedule.map((scheduleOrigin, k) => {
            const schedules = ProgramScheduleComponent.findReplacedSchedule(item, scheduleOrigin, dayFromCalendar);
            // console.log(curriculumSet);
            if (!curriculumSet) {
              curriculumSet = true;
              ProgramScheduleComponent.schedulesWithLesson = {};
              // console.log(curriculumSet);
              if (current_program.curriculum && current_program.curriculum.length > 0) {
                // console.log(current_program);
                const timeStartC = moment(schedules[0].start, 'HH:mm A');
                const curriculumstart = moment(current_program.curriculum[0].start_curriculum, 'YYYY-MM-DD HH:mm:ss');
                if (withTime === false) {
                  dayFromCalendar.hour(curriculumstart.hour()).minute(curriculumstart.minute());
                }
                const dayTime = dayFromCalendar.clone().hour(timeStartC.hour()).minute(timeStartC.minute());
                current_program.curriculum = current_program.curriculum.sort((a, b) => {
                  return moment(a.start_curriculum, 'YYYY-MM-DD HH:mm:ss').isBefore(moment(b.start_curriculum, 'YYYY-MM-DD HH:mm:ss')) ? -1 : 1;
                });
                // console.log(dayTime.isAfter(curriculumstart), dayTime.isSame(curriculumstart));
                const dayTimeDay = dayTime.clone().startOf('day');
                const curriculumstartDay = curriculumstart.clone().startOf('day');
                if (dayTime.isAfter(curriculumstart) || dayTimeDay.isSame(curriculumstartDay)) {
                  ProgramScheduleComponent.findInitLessonNumber(current_program, dayTime, withTime);
                }
                // console.log('**** init ****', ProgramScheduleComponent.lessonNumber);
                // console.log('**** init ****', dayTime.diff(curriculumstart));
              }
            }
            // console.log(schedules);
            schedules.map(schedule => {
              if (!schedule.canceled || schedule.canceled === false) {
                // if (ProgramScheduleComponent.schedulesWithLesson) {
                //   if (dayTime.isAfter(curriculumstart) || dayTimeDay.isSame(curriculumstartDay)) {
                //     ProgramScheduleComponent.findInitLessonNumber(current_program, dayTime, withTime);
                //   }
                // }
                let scheduleChecked;
                switch (schedule.repeat_time) {
                  case 'day':
                    scheduleChecked = Object.assign({}, schedule);
                    break;
                  case 'week':
                    // console.log(schedule);
                    if (schedule.dayName === dayFromCalendar.format('dddd').substring(0, 3).toLowerCase()) {
                      scheduleChecked = Object.assign({}, schedule);
                      // console.log(scheduleChecked);
                      // console.log(ProgramScheduleComponent.schedulesWithLesson);
                    }
                    break;
                  case 'month':
                    if (+schedule.day === +dayFromCalendar.date()) {
                      scheduleChecked = Object.assign({}, schedule);
                    }
                    break;
                  case 'none':
                    if (+schedule.day === +dayFromCalendar.date() && +schedule.month === (dayFromCalendar.month() + 1) && +schedule.year === dayFromCalendar.year()) {
                      scheduleChecked = Object.assign({}, schedule);
                    }
                    // console.log(scheduleChecked);
                    break;
                }
                // console.log(scheduleChecked);
                if (scheduleChecked && scheduleChecked.id) {
                  // if (ProgramScheduleComponent.schedulesWithLesson) {
                  //   if (dayTime.isAfter(curriculumstart) || dayTimeDay.isSame(curriculumstartDay)) {
                  //     ProgramScheduleComponent.findInitLessonNumber(current_program, dayTime, withTime);
                  //   }
                  // }
                  // console.log(scheduleChecked);
                  scheduleChecked.selectedDayNumber = +dayFromCalendar.date();
                  const classScheduleTimeStart = moment(scheduleChecked.start, 'HH:mm A');
                  const classScheduleTimeEnd = moment(scheduleChecked.end, 'HH:mm A');
                  const dayFromCalendarTimeStart = dayFromCalendar.clone().hour(classScheduleTimeStart.hour()).minute(classScheduleTimeStart.minute());
                  const dayFromCalendarTimeEnd = dayFromCalendar.clone().hour(classScheduleTimeEnd.hour()).minute(classScheduleTimeEnd.minute());
                  if (dayFromCalendarTimeStart.isBetween(dayFromCalendar, dayFromCalendarTimeEnd) && dayFromCalendarTimeStart.diff(dayFromCalendar, 'hour') < 1 ||
                      dayFromCalendar.isSame(dayFromCalendarTimeStart) || withTime === false
                  ) {
                    let date = dayFromCalendar.format('MMM Do YY');
                    if (!classesByDates[date]) {
                      classesByDates[date] = {};
                    }
                    // if (schedule.id === 102) {
                    //   console.log(item);
                    // }
                    // console.log(ProgramScheduleComponent.schedulesWithLesson);
                    // console.log(dayFromCalendar.format('ll'));
                    // console.log(scheduleChecked.id);
                    if (ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')] &&
                        (ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')][scheduleChecked.id])) {
                      scheduleChecked.lesson = ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')][schedule.id];
                      // scheduleChecked = ProgramScheduleComponent.bindClassWithLesson(scheduleChecked, current_program, dayFromCalendarTimeStart);
                      // console.log(ProgramScheduleComponent.schedulesWithLesson);
                    }
                    let classSchedule = Object.assign({}, item);
                    classSchedule.program_id = scheduleChecked.program_id;
                    classSchedule.program_name = scheduleChecked.program_name;
                    classSchedule.lesson = scheduleChecked.lesson;
                    classSchedule.selectedSchedule = scheduleChecked;
                    classSchedule.momentStart = dayFromCalendarTimeStart;
                    classSchedule.momentEnd = dayFromCalendarTimeEnd;
                    classSchedule.cssClass = classSchedule.id * 12 + 'fsdfss';
                    classSchedule.styles = ProgramScheduleComponent.getCssHeightTopAndDisabled(classSchedule, dayFromCalendar);
                    // console.log('+++++', classSchedule);
                    // if (schedule.id === 102) {
                    //   console.log(classSchedule);
                    // }
                    if (!classesByDates[date][+dayFromCalendar.date()]) {
                      classesByDates[date][+dayFromCalendar.date()] = {};
                    }
                    if (!classesByDates[date][+dayFromCalendar.date()][classSchedule.id]) {
                      if (withTime === false) {
                        classesByDates[date][+dayFromCalendar.date()][classSchedule.id] = [];
                      } else {
                        classesByDates[date][+dayFromCalendar.date()][classSchedule.id] = {};
                      }
                    }
                    if (withTime === true &&
                        !classesByDates[date][+dayFromCalendar.date()][classSchedule.id][dayFromCalendar.format(defaultFormat)]) {
                      classesByDates[date][+dayFromCalendar.date()][classSchedule.id][dayFromCalendar.format(defaultFormat)] = [];
                    }
                    if (withTime === true) {
                      classesByDates[date][+dayFromCalendar.date()][classSchedule.id][dayFromCalendar.format(defaultFormat)].push(classSchedule);
                    } else {
                      classesByDates[date][+dayFromCalendar.date()][classSchedule.id].push(classSchedule);
                    }
                  }
                }
              }
            });
          });
        });
      });
      // console.log(classesByDates);
      ProgramScheduleComponent.classesByDates[index] = classesByDates;
      return classesByDates;
    } else {
      return ProgramScheduleComponent.classesByDates[index];
    }
  }
  ngOnDestroy() {
    document.removeEventListener('click', () => {
      this.currentClass = null;
      const classes = document.getElementsByClassName('program-schedule-content-cell-class-inner');
      Object.keys(classes).forEach( item => {
        if (item) {
          classes[item].classList.remove('selected_class');
        }
      });
    }, false);
  }
  changeScale(event) {
    this.disablingPopups();
    let target = event.target.closest('span');
    if (!target) {
      target = event.target.getElementsByTagName('span')[0];
    }
    const currentScale = target.innerText.toLowerCase() as string;
    this.currentScheduleScale = this.schedulesScales.indexOf(currentScale);
  }
  onToday() {
    this.calendarViewDate = moment();
    this.resetSelectedCalendarDay();
    this.onTodaySubject.next('month');
  }
  onRight() {
    this.calendarViewDate = this.calendarViewDate.clone().add(1, 'month');
    this.resetSelectedCalendarDay();
    this.onRightSubject.next('month');
  }
  onLeft() {
    this.calendarViewDate = this.calendarViewDate.clone().add(-1, 'month');
    this.resetSelectedCalendarDay();
    this.onLeftSubject.next('month');
  }
  setCurrentClass(event) {
    if (event) {
      // console.log(this.currentClass);
      if (event.selectedDay) {
        const selectedDay  = moment(event.selectedDay);
        this.selectedDay = selectedDay.date();
        this.selectedMonth = selectedDay.month() + 1;
      }
      if (!this.currentClass || this.currentClass.selectedSchedule.id !== event.selectedSchedule.id) {
        this.currentClass = event;
        console.log(this.currentClass);
        // setTimeout(() => {
        //   this.getClassStudents(event);
        // }, 2);
      } else {
        this.currentClass = null;
      }
      // this.currentClass && this.currentClass.selectedSchedule.id == event.selectedSchedule.id ? this.currentClass = null : this.getClassStudents(event);
    } else {
      // console.log(event);
      // this.currentClass = null;
    }
  }
  setCurrentDay(day) {
    this.currentDay = this.currentDay && this.currentDay.styles.top === day.styles.top && this.currentDay.styles.left === day.styles.left ? null : day;
    // console.log(day);
  }
  onCalendarDaySelected(event) {
    if (!event) {
      return;
    }
    this.selectedCalendarDate = moment([
      event.year || this.calendarViewDate.year(),
      Number(event.month) - 1,
      Number(event.day)
    ]);
    this.selectedDaySchedules = this.sortSchedules((event.schedules || []).map(schedule => {
      return this.enrichScheduleForDisplay(schedule, this.selectedCalendarDate);
    }));
  }
  resetSelectedCalendarDay() {
    this.selectedCalendarDate = null;
    this.selectedDaySchedules = [];
  }
  getScheduleTime(schedule): string {
    const scheduleSource = schedule && schedule.selectedSchedule ? schedule.selectedSchedule : schedule;
    const start = scheduleSource && scheduleSource.start ? scheduleSource.start : '';
    const end = scheduleSource && scheduleSource.end ? scheduleSource.end : '';

    return start && end ? start + ' ~ ' + end : 'Time not set';
  }
  getScheduleTitle(schedule): string {
    const lesson = this.getScheduleLesson(schedule);

    if (lesson && lesson.name) {
      return lesson.name;
    }

    const className = this.getScheduleClassName(schedule);

    return schedule && (className || schedule.name || schedule.program_name)
      ? className || schedule.name || schedule.program_name
      : 'Class';
  }
  getScheduleMeta(schedule): string {
    const teachers = this.getScheduleTeachers(schedule);
    let teacherName = '';

    if (Array.isArray(teachers) && teachers.length > 0) {
      teacherName = teachers[0].name || teachers[0].first_name || '';
    } else if (typeof teachers === 'string') {
      teacherName = teachers;
    }

    return teacherName || schedule.program_name || this.program.program_name || schedule.repeat_time || 'No teacher';
  }
  hasUsableLesson(schedule): boolean {
    const lesson = this.getScheduleLesson(schedule);

    return !!(lesson && lesson.id);
  }
  openScheduleLesson(programScheduleDay, schedule) {
    const enrichedSchedule = this.enrichScheduleForDisplay(schedule, this.selectedCalendarDate || moment());

    if (!this.hasUsableLesson(enrichedSchedule)) {
      return;
    }

    programScheduleDay.onOpenViewCurriculumModal(enrichedSchedule);
  }
  private enrichScheduleForDisplay(schedule, selectedDate = null) {
    const scheduleSource = schedule && schedule.selectedSchedule ? schedule.selectedSchedule : schedule;
    const classItem = this.getProgramClass(scheduleSource ? scheduleSource.class_id : null);
    const lesson = this.resolveScheduleLesson(schedule, selectedDate);
    const enriched = Object.assign({}, schedule);

    if (lesson) {
      enriched.lesson = lesson;
    }
    if (!enriched.class_name && classItem && classItem.name) {
      enriched.class_name = classItem.name;
    }
    if ((!enriched.teachers || enriched.teachers.length === 0) && classItem && classItem.teachers) {
      enriched.teachers = classItem.teachers;
    }

    return enriched;
  }
  private getScheduleLesson(schedule) {
    if (!schedule || !schedule.lesson) {
      return null;
    }

    if (schedule.lesson.id) {
      return this.getProgramLesson(schedule.lesson.id) || schedule.lesson;
    }

    return schedule.lesson;
  }
  private resolveScheduleLesson(schedule, selectedDate = null) {
    const existingLesson = this.getScheduleLesson(schedule);
    const scheduleSource = schedule && schedule.selectedSchedule ? schedule.selectedSchedule : schedule;
    const dateMoment = selectedDate && moment(selectedDate).isValid() ? moment(selectedDate) : null;

    if (existingLesson && existingLesson.name) {
      return existingLesson;
    }

    if (!scheduleSource || !scheduleSource.id || !dateMoment) {
      return existingLesson;
    }

    let lesson = this.getCachedScheduleLesson(scheduleSource.id, dateMoment);

    if (!lesson && this.program) {
      ProgramScheduleComponent.getClassByDate(this.program, [this.program], dateMoment.toDate(), {}, false, moment(), 'MMM Do YY HH:mm A');
      lesson = this.getCachedScheduleLesson(scheduleSource.id, dateMoment);
    }

    return lesson && lesson.id ? this.getProgramLesson(lesson.id) || lesson : lesson || existingLesson;
  }
  private getCachedScheduleLesson(scheduleId, selectedDate) {
    const dateKey = moment(selectedDate).format('ll');

    return ProgramScheduleComponent.schedulesWithLesson[dateKey]
      ? ProgramScheduleComponent.schedulesWithLesson[dateKey][scheduleId]
      : null;
  }
  private getProgramLesson(lessonId) {
    let foundLesson = null;
    const curriculums = this.program && this.program.curriculum ? this.program.curriculum : [];

    curriculums.map(curriculum => {
      const lessons = curriculum.lessons || [];
      lessons.map(lesson => {
        if (String(lesson.id) === String(lessonId)) {
          foundLesson = lesson;
        }
      });
    });

    return foundLesson;
  }
  private getProgramClass(classId) {
    let foundClass = null;
    const classes = this.program && this.program.classes ? this.program.classes : [];

    classes.map(classItem => {
      if (String(classItem.id) === String(classId)) {
        foundClass = classItem;
      }
    });

    return foundClass;
  }
  private getScheduleClassName(schedule): string {
    const scheduleSource = schedule && schedule.selectedSchedule ? schedule.selectedSchedule : schedule;
    const classItem = this.getProgramClass(scheduleSource ? scheduleSource.class_id : null);

    return schedule && (schedule.class_name || (classItem && classItem.name))
      ? schedule.class_name || classItem.name
      : '';
  }
  private getScheduleTeachers(schedule) {
    const scheduleSource = schedule && schedule.selectedSchedule ? schedule.selectedSchedule : schedule;
    const classItem = this.getProgramClass(scheduleSource ? scheduleSource.class_id : null);

    return schedule && schedule.teachers && schedule.teachers.length ? schedule.teachers : classItem && classItem.teachers ? classItem.teachers : [];
  }
  private doesScheduleMatchDate(schedule, date): boolean {
    const repeat = String(schedule.repeat_time || '').toLowerCase();
    const scheduleDay = String(schedule.dayName || schedule.fullDayName || '').toLowerCase();
    const shortDay = date.format('ddd').toLowerCase();
    const fullDay = date.format('dddd').toLowerCase();
    const matchesDayName = scheduleDay === shortDay || scheduleDay === fullDay || scheduleDay.indexOf(shortDay) === 0;

    if (repeat === 'day') {
      return true;
    }
    if (repeat === 'week') {
      return matchesDayName;
    }
    if (repeat === 'month') {
      return +schedule.day === date.date();
    }
    if (schedule.date && moment(schedule.date).isValid()) {
      return moment(schedule.date).isSame(date, 'day');
    }

    return +schedule.day === date.date()
      && +schedule.month === date.month() + 1
      && +schedule.year === date.year();
  }
  private sortSchedules(schedules: any[]): any[] {
    return schedules.slice().sort((a, b) => {
      const scheduleA = a && a.selectedSchedule ? a.selectedSchedule : a;
      const scheduleB = b && b.selectedSchedule ? b.selectedSchedule : b;

      return moment(scheduleA.start || '00:00 AM', 'HH:mm A')
        .diff(moment(scheduleB.start || '00:00 AM', 'HH:mm A'));
    });
  }
  disablingPopups() {
    this.currentClass = null;
    this.currentDay = null;
  }
  getClassesArrayItem(currentDay) {
    let classes = [];
    Object.keys(currentDay.classes).map( item => {
      // console.log(item);
      currentDay.classes[item].map( day => {
        classes.push(day.selectedSchedule);
      });
      // console.log(currentDay.classes[item]);
      // console.log(currentDay.classes[item][0].selectedSchedule);
      // classes.push(currentDay.classes[item][0].selectedSchedule);
    });
    return classes;
  }
  // getProgramStudents() {
  //   this.studentService.getProgramStudents(this.program.id).subscribe(
  //     (resp: {data: User[]}) => {
  //       resp.data.map( student => {
  //         console.log(student);
  //         if (student.classes_id.length > 0 && student.programs_id.includes(this.program.id)) {
  //           student.classes_id.map( class_id => {
  //             if (!this.students[class_id]) {
  //               this.students[class_id] = [];
  //             }
  //             this.students[class_id].push(student);
  //           })
  //         }
  //       });
  //       console.log(this.students);
  //     }
  //   );
  // }
  async getClassStudents(classc) {
    await this.studentService.getClassStudents(classc.id).subscribe(
        (resp: {data: User[]}) => {
          classc.students = resp.data;
          this.currentClass = classc;
        }
    );
  }
  openEditModal(classc) {
    ProgramCreateComponent.source = ProgramCreateComponent.source_class_edit;
    ProgramCreateComponent.selectedDate = classc.selectedDay;
    ProgramCreateComponent.program = this.program;
    // console.log(classc);
    ProgramCreateComponent.editedItem = {
      id: classc.id,
      name: classc.name,
      description: classc.description,
      schedule: classc.schedule,
      selectedSchedule: classc.selectedSchedule,
      teachers: classc.teachers,
    };
    const daySelected =  moment(classc.selectedDay);
    ProgramCreateComponent.sourceSchedule = ProgramClassesComponent.reorganizeSchedule(this.program, [classc.selectedSchedule.id], daySelected);
    this.createDialog = this.dialog.open(ProgramCreateComponent, { disableClose: true });
    this.createDialog.disableClose = true;
    ProgramCreateComponent.dialogRef = this.createDialog;
    this.createDialog.afterClosed().subscribe(result => {
      this.createDialog.close();
    });
  }
  openCreateModal() {
    ProgramCreateComponent.source = ProgramCreateComponent.source_class;
    ProgramCreateComponent.program = this.program;
    ProgramCreateComponent.editedItem = null;
    ProgramCreateComponent.sourceSchedule = ProgramClassesComponent.reorganizeSchedule(this.program);
    this.createDialog = this.dialog.open(ProgramCreateComponent);
    ProgramCreateComponent.dialogRef = this.createDialog;
    this.createDialog.afterClosed().subscribe(result => {
      this.createDialog.close();
    });
  }
  openDeleteModal(classc) {
    const schedule = classc.selectedSchedule;
    if (schedule.replaced_schedule) {
      this.openConfirmPopup(schedule, classc);
    } else {
      this.openConfirmPopup(schedule, classc, true);
    }
  }
  actionDelete(body: {schedule: Schedule, classc: Class}, canceled: boolean) {
    if (canceled) {
      body.schedule.canceled = true;
    } else {
      body.schedule.deleted = true;
    }
    this.onEditClass(body.classc, body.schedule);
  }
  static findInitLessonNumber(program, dayTime, withTime = true) {
    // console.log(program);
    ProgramScheduleComponent.schedulesWithLesson = {};
    ProgramScheduleComponent.lessonNumber = {};
    if (program.schedule) {
      program.curriculum.map(curr => {
        if (curr.start_curriculum) {
          const curriculumstart = moment(curr.start_curriculum, 'YYYY-MM-DD HH:mm:ss');
          const dayTimeDay = dayTime.clone().startOf('day');
          const curriculumstartDay = curriculumstart.clone().startOf('day');
          if (dayTime.isAfter(curriculumstart) || dayTimeDay.isSame(curriculumstartDay)) {
            // console.log(curr.start_curriculum);
            const countDays = dayTime.endOf('month').diff(curriculumstart, 'days');  // console.log(newDay.format('ll'));
            ProgramScheduleComponent.lessonNumber[curr.program_id ? curr.program_id + '|' + curr.id : curr.id] = 0;
            new Array(countDays + 1).fill(0).map((day, i) => {
              // console.log(countDays);
              const newDay = curriculumstart.clone().add(i, 'days');
              program.schedule = program.schedule.sort((a: Schedule, b: Schedule) => {
                return moment(a.start, 'HH:mm A').month(a.month).date(+a.day).year(+a.year)
                    .isBefore(moment(b.start, 'HH:mm A').month(b.month).date(+b.day).year(+b.year)) ? -1 : 1;
              });
              // console.log(program);
              program.schedule.map((scheduleOrigin) => {
                if (scheduleOrigin.class_id && (curr.program_id ? scheduleOrigin.program_id === curr.program_id : true)) {
                  // console.log("000000000000000000000");
                  const schedules = ProgramScheduleComponent.findReplacedSchedule(program, scheduleOrigin, newDay);
                  schedules.map(schedule => {
                    if (!schedule.canceled || schedule.canceled === false) {
                      let scheduleChecked;
                      switch (schedule.repeat_time) {
                        case 'day':
                          scheduleChecked = Object.assign({}, schedule);
                          break;
                        case 'week':
                          if (schedule.dayName === newDay.format('dddd').substring(0, 3).toLowerCase()) {
                            scheduleChecked = Object.assign({}, schedule);
                          }
                          break;
                        case 'month':
                          if (+schedule.day === +newDay.date()) {
                            scheduleChecked = Object.assign({}, schedule);
                          }
                          break;
                        case 'none':
                          if (+schedule.day === +newDay.date() && +schedule.month === (newDay.month() + 1) && +schedule.year === newDay.year()) {
                            scheduleChecked = Object.assign({}, schedule);
                          }
                          break;
                      }
                      // console.log("1111111111111111111111");
                      if (scheduleChecked && scheduleChecked.id) {
                        const classScheduleTimeStart = moment(scheduleChecked.start, 'HH:mm A');
                        const dayFromCalendarTimeStart = newDay.clone().hour(classScheduleTimeStart.hour()).minute(classScheduleTimeStart.minute());
                        // console.log(countDays, curr, dayTime.format('ll'),dayFromCalendarTimeStart.format('ll') );
                        if (!ProgramScheduleComponent.schedulesWithLesson[dayFromCalendarTimeStart.format('ll')] ||
                            (!ProgramScheduleComponent.schedulesWithLesson[dayFromCalendarTimeStart.format('ll')][scheduleChecked.id])) {
                          scheduleChecked = ProgramScheduleComponent.bindClassWithLesson(scheduleChecked, program, curr, dayFromCalendarTimeStart);
                          // console.log('55555');
                          // console.log(ProgramScheduleComponent.schedulesWithLesson);
                        }
                        // console.log(scheduleChecked);
                        // console.log(ProgramScheduleComponent.lessonNumber);
                        // console.log(ProgramScheduleComponent.schedulesWithLesson);
                      }
                    }
                  });
                }
              });
            });
          }
        }
      });
    }
  }
  contentReady() {
    this.scheduleProgram.next('scheduleProgram');
  }
  ngOnInit() {
    this.authStore.subscribe(
        (val) => {
          // console.log(val);
          const auth = val.auth;
          if (auth && auth.user) {
            this.user = auth.user;
          }
        }
    );
    this.programSubject.subscribe(
        resp => {
          // console.log(resp);
          this.program = resp;
          // console.log(this.currentClass);
          // if (this.program.lastAction === ActionTypes.ADD_PROGRAM || this.program.lastAction === ActionTypes.CLOSE_POPUP || this.program.lastAction === ActionTypes.UPDATE_PROGRAM) {
          //   this.createDialog.open();
          // }
        }
    );
    document.addEventListener('click', (event) => {
      const target = event.target as HTMLInputElement;
      if (target && !target.classList.contains('cdk-overlay-backdrop')) {
        this.currentClass = null;
        this.currentDay = null;
        this.onClosePopupClass.next(true);
        const classes = document.getElementsByClassName('program-schedule-content-cell-class-inner');
        Object.keys(classes).forEach(item => {
          if (item) {
            classes[item].classList.remove('selected_class');
          }
        });
      }
    }, false);
    const content = document.getElementsByClassName('content');
    content.item(0).addEventListener('scroll', () => {
      this.currentClass = null;
      this.currentDay = null;
      this.onClosePopupClass.next(true);
      const classes = document.getElementsByClassName('program-schedule-content-cell-class-inner');
      Object.keys(classes).forEach( item => {
        if (item) {
          classes[item].classList.remove('selected_class');
        }
      });
    }, false);
    if (this.isAdmin() && this.program && this.program.preview) {
      let classIds = [];
      this.program.classes.map( cl => classIds.push(cl.id));
      if (classIds.length > 0) {
        this.classService.getTeachers(classIds).subscribe(
            (resp: {data: {id:number, class_id: number, name: string}[]}) => {
              resp.data.map( item => {
                this.program.classes.map( (cl, i) => {
                  if (cl.id === item.class_id) {
                    if (!this.program.classes[i].teachers) {
                      this.program.classes[i].teachers = [];
                    }
                    let found = false;
                    this.program.classes[i].teachers.map( teacher => {
                      if (teacher.id === item.id) {
                        found = true;
                      }
                    });
                    if (found === false) {
                      this.program.classes[i].teachers.push(item);
                    }
                  }
                });
              });
              this.program.preview = false;
              this.programStore.dispatch(new UpdateProgram(this.program));
            }
        )
      }
    }
  }
  openConfirmPopup(schedule, classc, repeatEnable = false) {
    ConfirmModalComponent.insertedObject = this;
    ConfirmModalComponent.repeatable = repeatEnable;
    ConfirmModalComponent.methodDelete = 'actionDelete';
    ConfirmModalComponent.methodDeleteAll = 'actionDelete';
    ConfirmModalComponent.methodDeleteParam = {schedule: schedule, classc: classc};
    ConfirmModalComponent.methodDeleteAllParam = true;
    ConfirmModalComponent.textModal = 'Delete?';
    ConfirmModalComponent.textButton = 'Delete';
    this.confirmDialog = this.dialog.open(ConfirmModalComponent);
    ConfirmModalComponent.modalRef = this.confirmDialog;
    this.confirmDialog.afterClosed().subscribe(result => {
      this.confirmDialog.close();
    });
  }
  static bindClassWithLesson(schedule: Schedule, program, curriculum: Curriculum, dayFromCalendar) {
    if ((schedule.program_id === program.id || curriculum.program_id) && curriculum.start_curriculum) {
      let curriculumstart = moment(curriculum.start_curriculum, 'YYYY-MM-DD HH:mm:ss');
      let curriculumEnd = moment(curriculum.end_curriculum, 'YYYY-MM-DD HH:mm:ss');
      // console.log(dayFromCalendar.format('ll'), curriculum);
      const dayFromCalendarDay = dayFromCalendar.clone().startOf('day');
      const curriculumstartDay = curriculumstart.clone().startOf('day');
      if ((dayFromCalendar.isAfter(curriculumstart) || dayFromCalendarDay.isSame(curriculumstartDay)) && !dayFromCalendar.isAfter(curriculumEnd)) {
        if (curriculum.lessons[ProgramScheduleComponent.lessonNumber[curriculum.program_id ? curriculum.program_id + '|' + curriculum.id : curriculum.id]]) {
          if (curriculum.end_curriculum) {
            // console.log("0000000000");
            if ((dayFromCalendar.isSame(curriculumstart) || dayFromCalendar.isAfter(curriculumstart))
                && (dayFromCalendar.isBefore(curriculumEnd) || dayFromCalendar.isSame(curriculumEnd))) {
              if (ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')] &&
                  (ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')][schedule.id])) {
                schedule.lesson = ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')][schedule.id];
              } else {
                ProgramScheduleComponent.setAndUpdate(program, dayFromCalendar, curriculum, schedule);
                if (ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')]  &&
                    (ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')][schedule.id])) {
                  schedule.lesson = ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')][schedule.id];
                }
              }
              // schedule.lesson = program.curriculum.lessons[ProgramScheduleComponent.lessonNumber];
              // ProgramScheduleComponent.setAndUpdate(program, dayFromCalendar, schedule)
            }
          } else {
            // console.log(ProgramScheduleComponent.schedulesWithLesson, dayFromCalendar.format('ll'), schedule.id);
            ProgramScheduleComponent.setAndUpdate(program, dayFromCalendar, curriculum, schedule);
            // console.log(ProgramScheduleComponent.schedulesWithLesson, dayFromCalendar.format('ll'), schedule);
            if (ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')] &&
                (ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')][schedule.id])) {
              // console.log('saved');
              schedule.lesson = ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')][schedule.id];
            }
          }
          // console.log('*****', schedule);
        }
      }
    }
    return schedule;
  }
  static findReplacedSchedule(item, schedule, dayFromCalendar) {
    // if (schedule.id === 102) {
    //   console.log(dayFromCalendar);
    //   console.log(schedule);
    // }
    if (!item.replaced_schedule) {
      return schedule;
    }
    let foundSch = [];
    // console.log(item);
    // console.log(schedule);
    item.replaced_schedule.map( sch => {
      if (sch.replaced_schedule === schedule.id) {
        const day = moment().year(sch.year).month(sch.month - 1).date(sch.day);
        // console.log(dayFromCalendar.date());
        // console.log(dayFromCalendar);
        // console.log(day);
        // console.log(day);
        // console.log(sch);
        if (dayFromCalendar.month() === day.month() && dayFromCalendar.year() === day.year() && dayFromCalendar.date() === day.date()) {
          foundSch.push(sch);
        }
      }
    });
    // if (schedule.id === 102) {
    //   console.log(foundSch.length === 0 ? [schedule] : foundSch);
    //   console.log(foundSch);
    // }
    return foundSch.length === 0 ? [schedule] : foundSch;
  }
  static setAndUpdate(program, dayFromCalendar, curriculum, schedule) {
    if (!ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')]) {
      ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')] = {};
    }
    if (!ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')][schedule.id] ||
        ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')][schedule.id] !== 0) {
      ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')][schedule.id] = {};
      const idC = curriculum.program_id ? curriculum.program_id + '|' + curriculum.id : curriculum.id;
      let lesson = curriculum.lessons[ProgramScheduleComponent.lessonNumber[idC]];
      lesson.order = curriculum.order;
      lesson.curriculum_id = curriculum.id;
      lesson.program_id = curriculum.program_id;
      ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')][schedule.id] = lesson;
      ProgramScheduleComponent.lessonNumber[idC] === curriculum.lessons.length - 1 ?
          ProgramScheduleComponent.lessonNumber[idC] = 0 : ProgramScheduleComponent.lessonNumber[idC]++;
      // console.log(ProgramScheduleComponent.lessonNumber);
      // console.log(curriculum);
      // console.log(schedule);
    }
    // console.log(ProgramScheduleComponent.schedulesWithLesson);
  }
  onEditClass(classc: Class, schedule, delete_class = false) {
    const date = {};
    date[moment(classc.selectedDay).format('YYYY-MM-DD')] = [schedule];
    this.classService.editClass({
      class_name: classc.name,
      delete_class: delete_class,
      class_description: classc.description,
      schedule: date,
      repeat_time: 'none',
      program_id: this.program.id,
      class_id: classc.id,
      unique_schedule: !schedule.replaced_schedule,
      replaced_schedule: null,
    }).subscribe(
        (resp: {data: {classes: Class[], schedules: Schedule[], replaced_schedules: Schedule[]}}) => {
          let deleteClass = false;
          resp.data.classes.map( item => {
            // console.log(item);
            if (item.schedule.length === 0 && item.replaced_schedule.length === 0) {
              this.onEditClass(item, item.schedule, true);
              deleteClass = true;
            }
          });
          if (!deleteClass) {
            this.program.replaced_schedule = resp.data.replaced_schedules;
            this.program.schedule = resp.data.schedules;
            this.program.classes = resp.data.classes;
            this.programStore.dispatch(new UpdateProgram(this.program));
          }
          if (this.confirmDialog) {
            this.confirmDialog.close();
          }
          // console.log(resp);
        }
    );
  }
  static getCssHeightTopAndDisabled(item, dayFromCalendar) {
    const minuteStart = item.momentStart.diff(dayFromCalendar, 'minute'),
        timeCellHeight = 25.3,
        minutPerPixel = timeCellHeight / 60,
        durations = moment.duration(item.momentEnd.diff(item.momentStart)),
        height = ((durations.hours() * 60 + durations.minutes() - 2) * minutPerPixel) + 'px',
        top = (minuteStart > 0 ? minuteStart : 1) * minutPerPixel - 2 + 'px';
    return { 'margin-top': top, height: height};
  }
  onOpenViewCurriculumModal(lesson) {
    let curriculum;
    const curriculums = [];
    this.program.curriculum.map( curr => {
      curr.lessons.map( item => {
        if (item.id === lesson.id) {
          curriculum = curr;
        }
      });
    });
    if (curriculum) {
      this.programs.map( item => {
        item.curriculum.map( curr => {
          if (curr.id !== curriculum.id) {
            curriculums.push(curr);
          }
        });
      });
      ViewCurriculumComponent.source = 'student';
      ViewCurriculumComponent.onlyLesson = true;
      ViewCurriculumComponent.curriculum = curriculum;
      ViewCurriculumComponent.program = this.program;
      ViewCurriculumComponent.initLesson = lesson;
      ViewCurriculumComponent.fullContent = false;
      this.viewCirriculumDialog = this.dialog.open(ViewCurriculumComponent, {
        panelClass: 'mkc-dashboard-lesson-dialog',
        backdropClass: 'mkc-dashboard-lesson-backdrop'
      });
      ViewCurriculumComponent.modalRef = this.viewCirriculumDialog;
      this.viewCirriculumDialog.afterClosed().subscribe(result => {
        this.viewCirriculumDialog.close();
      });
    }
  }
  isAdmin() {
    return this.source === 'admin';
  }
  checkin() {
    if (this.currentClass && this.currentClass.selectedSchedule) {
      const schedule = this.currentClass.selectedSchedule;
      const body = {
        user_id: [this.user.id],
        program_id: schedule.program_id,
        schedule_id: schedule.id,
        class_id: this.currentClass.id,
        lesson_id: schedule.lesson ? schedule.lesson.id : null,
        created_at: moment().format('YYYY-MM-DD HH:mm:ss')
        // subscription_id: schedule.subscription_id,
      };
      this.attendanceService.checkIn(body).subscribe(
          (resp: { data: any, status: number }) => {
            if (resp.status === 200) {
              if (resp.data) {
                this.user.current_lesson = resp.data[resp.data.length - 1];
                // this.user.yearAttendanceFromApi = resp.data;
                this.authStore.dispatch(new UpdateAuthUser({current_lesson: this.user.current_lesson, yearAttendanceFromApi: resp.data}));
              }
            } else if (resp.status === 11200) {
              if (resp.data.error) {
                ConfirmModalComponent.textModal = resp.data.error;
              }
              ConfirmModalComponent.insertedObject = this;
              ConfirmModalComponent.source = 'need_charge';
              ConfirmModalComponent.methodDelete = 'goToMembershipPage';
              this.confirmDialog = this.dialog.open(ConfirmModalComponent);
              ConfirmModalComponent.modalRef = this.confirmDialog;
            }
            // console.log(resp);
          }
      );
    }
  }
  goToMembershipPage() {
    this.router.navigate(['/payments']);
  }
  isGoing() {
    if (this.selectedMonth && this.selectedDay && this.currentClass && this.currentClass.selectedSchedule) {
      const schedule = this.currentClass.selectedSchedule;
      const scheduleTimeStart = moment(schedule.start, 'HH:mm A').month(this.selectedMonth - 1).date(this.selectedDay);
      const scheduleTimeEnd = moment(schedule.end, 'HH:mm A').month(this.selectedMonth - 1).date(this.selectedDay);
      if (this.source === 'student') {
        scheduleTimeStart.add('-1', 'hours');
      }
      const condition1 = moment().isBetween(scheduleTimeStart, scheduleTimeEnd) || moment().isSame(scheduleTimeStart);
      let condition2 = true;
      // console.log(scheduleTimeStart, scheduleTimeEnd, this.user);
      // if (this.user && this.user.current_lesson && this.user.current_lesson.end) {
      //   if (this.user.current_lesson.schedule_id) {
      //     const currentLessonEndMoment = moment(this.user.current_lesson.end, 'HH:mm A').add(10, 'minutes');
      //     const currentLessonMoment = moment(this.user.current_lesson.created_at, 'YYYY-MM-DD HH:mm:ss').hours(currentLessonEndMoment.hours()).minutes(currentLessonEndMoment.minutes());
      //     condition2 = moment().isSameOrAfter(currentLessonMoment);
      //   } else {
      //     this.authStore.dispatch(new UpdateAuthUser({current_lesson: null}));
      //   }
      // }
      return condition1 && condition2;
    }
  }
}
